module.exports = __webpack_public_path__ + "static/media/logo.201f1128.svg";